import React, { Fragment } from "react";
import Navbar2 from "../../components/Navbar2";
import ServiceSingleSection from "../../components/ServiceSingleSection";
import Footer from "../../components/footer";
import Scrollbar from "../../components/scrollbar";
import Hero2 from "../../components/hero2";
import SectionRH from "../../components/SectionRH";

const ServiceSinglePage = () => {
  return (
    <Fragment>
      <Navbar2 />
      <Hero2 />
      <ServiceSingleSection />
      <SectionRH />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default ServiceSinglePage;
